import { Stack, styled } from '@mui/material';
import ToggleButton from 'pages/AIMusicGenerator/components/ToggleButton';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  background: theme.palette.grey[800],
}));

export const PromptTypeToggleButton = styled(ToggleButton)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 'bold',
  width: '100%',
  height: '100%',
  borderColor: 'transparent',
  textTransform: 'none',
  borderRadius: theme.spacing(1),
  transition: 'background-color 0.3s',
  '&.Mui-selected': {
    color: theme.palette.grey[900],
    backgroundColor: theme.palette.grey[50],
  },
  color: theme.palette.grey[400],
  backgroundColor: theme.palette.grey[800],
}));
